import { prepareUrl } from '@/helpers/UrlHelpers';
import ApiEndpoints from '@/config/ApiEndpoints';
import ApiService from '@/services/ApiService';

export default class AddUserToWeeklyEmail {
    apiService

    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);

        this.apiService.enableAuth();
    }

    handle(userId) {
        let url = prepareUrl(ApiEndpoints['users.preferences.weekly-email.store'], [userId]);

        return this.apiService.post(url);
    }
}
